import {Grid} from '@logistics-frontend/blocks'
import {Button} from '@logistics-frontend/blocks/lpc/button'
import {RequirementOption} from '@yandex-taxi/js-integration-api'
import {useRequirementValue} from '@yandex-taxi/react-integration-api'
import React from 'react'

import {useButtonClasses, useClasses} from '../classes'
import {useRequirementOptionsWithDefault} from './hooks'
import {Props} from './types'

const CargoLoadersRequirement: React.FC<Props> = ({requirement}) => {
  const {default: defaultValue, name} = requirement
  const classes = useClasses()
  const buttonClasses = useButtonClasses()
  const [{value = defaultValue, touched, error}, {setValue, setTouched}] = useRequirementValue<number>(name)
  const options = useRequirementOptionsWithDefault(requirement) || []

  const errorClassName = !!(touched && error) ? classes.buttonError : undefined
  const index = options.findIndex(opt => opt.value === value)
  const currOption: RequirementOption = options[index]
  const nextOption: RequirementOption | undefined = options[index + 1]
  const prevOption: RequirementOption | undefined = options[index - 1]

  const changeHandler = (option: RequirementOption) => {
    return function _changeHandler() {
      if (option) {
        // @ts-expect-error не много кривой тип RequirementOption[value]
        const value: number | undefined = option.value === defaultValue ? undefined : option.value

        setValue(value)
        setTouched(true)
      }
    }
  }

  return (
    <Grid alignItems="center" spacing={1} container>
      <Grid direction="column" sm={12} container item md>
        <Grid className={classes.boldTitle} item>
          {requirement.label}
        </Grid>
        <Grid className={classes.subtitle} item>
          {currOption.title}
        </Grid>
      </Grid>
      <Grid alignItems="center" className={classes.buttonsContainer} justify="flex-end" wrap="nowrap" container item md>
        <Button
          classes={buttonClasses}
          className={errorClassName}
          disabled={!prevOption}
          onClick={changeHandler(prevOption)}
        >
          &ndash;
        </Button>
        <Grid className={classes.counter} item>
          {value}
        </Grid>
        <Button
          classes={buttonClasses}
          className={errorClassName}
          disabled={!nextOption}
          onClick={changeHandler(nextOption)}
        >
          +
        </Button>
      </Grid>
    </Grid>
  )
}

export default CargoLoadersRequirement
